import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Label,
    Input,
    Col,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export default function RoomsRange({
    pageSettings,
    saveIntegration
}) {
    const [roomNoList, setRoomNoList] = useState([{
        startRoomNo: "",
        endRoomNo: ""
    }]);
    useEffect(() => {
        if (pageSettings.roomNumberRange !== undefined && pageSettings.roomNumberRange.length > 0) {
            setRoomNoList(pageSettings.roomNumberRange);
        }
    }, [pageSettings]);
    const AddLinks = () => {
        let links = [...roomNoList];;
        links.push({
            startRoomNo: '',
            endRoomNo: '',
        });
        setRoomNoList(links);
    };

    const RemoveLinks = (index) => {
        const values = [...roomNoList];
        values.splice(index, 1);
        setRoomNoList(values);
    };
    const handleChange = (e, index) => {
        const values = [...roomNoList];
        if (e.target.name === 'startNumber') {
            values[index].startRoomNo = e.target.value;
        }
        else if (e.target.name === 'endNumber') {
            values[index].endRoomNo = e.target.value;
        }
        setRoomNoList(values);
    }
    const handleSave = () => {
        let setting = pageSettings;
        setting.roomNumberRange = roomNoList;
        saveIntegration({
            pageSettings: setting
        });
    };
    return (<Fragment>
        <Row>
            <Col className='col-md-12 mb-3'>
                <Row>
                    <Colxx md={5} className='mt-2'><Label>Start Room #</Label></Colxx>
                    <Colxx md={5} className='mt-2'><Label>End Room #</Label></Colxx>
                    <Colxx md={2} className='mt-2'></Colxx>

                </Row>
                {roomNoList.length > 0 && roomNoList.map((room, i) => (
                    <Row>
                        <Colxx md={5} className='mt-2'>
                            <Input
                                type="number"
                                value={room.startRoomNo}
                                name='startNumber'
                                onChange={(e) => handleChange(e, i)}
                            />
                        </Colxx>
                        <Colxx md={5} className='mt-2'>
                            <Input
                                type="number"
                                value={room.endRoomNo}
                                name='endNumber'
                                onChange={(e) => handleChange(e, i)}
                            />
                        </Colxx>
                        <Colxx md={2} className='mt-2'>
                            <Label></Label>
                            <Button
                                style={{ backGround: 'red' }}
                                color="danger"
                                size="xs"
                                outline
                                onClick={() => RemoveLinks(i)}
                            >-</Button>
                        </Colxx>
                    </Row>
                ))}
            </Col>
            <Col className='col-md-12 mb-3 text-center'>
                <Separator className="mt-5" />
                <Button
                    size="xs"
                    color="success"
                    outline
                    style={{ marginTop: '20px', display: 'inline-block' }}
                    onClick={AddLinks}
                >
                    + <IntlMessages id='dashboards.add-room' />
                </Button>
                <Button
                    size="xs"
                    color="primary"
                    className="ml-2"

                    style={{ marginTop: '20px', display: 'inline-block' }}
                    onClick={() => handleSave()}
                >
                    Save
                </Button>
            </Col>
        </Row>
    </Fragment>);
}